import { StyledFormElements } from '@tmh-website/ui/FormElements';
import transparentize from 'polished/lib/color/transparentize';
import styled, { css } from 'styled-components';
import { FormElementThemeColor, formElementThemes } from '@tmh-website/ui/FormElements';

const resizeHandlerSvg =
  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" stroke="%STROKE%"><path d="M4.487 10.141l5.657-5.657M.598 9.788L9.79.595" stroke-linecap="round" stroke-linejoin="round"/></svg>';

interface TextareaProps {
  $themeColor: FormElementThemeColor;
  $extraPaddingBottom: boolean;
}

export const Textarea = styled(StyledFormElements.Input)<TextareaProps>`
  padding-top: 20px !important;
  resize: vertical;
  ${props =>
    props.$extraPaddingBottom &&
    css`
      padding-bottom: 18px !important;
    `};

  &::-webkit-resizer {
    background-image: ${props =>
      `url("data:image/svg+xml,${encodeURIComponent(
        resizeHandlerSvg.replace(
          '%STROKE%',
          transparentize(0.6, props.theme.color[formElementThemes[props.$themeColor].text])
        )
      )}")`};
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
`;

export const ScrollLabelUnderlay = styled.div<{ $themeColor: FormElementThemeColor; $isDisabled: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 18px;
  background-color: ${props => props.theme.color[formElementThemes[props.$themeColor].background.normal]};

  ${props =>
    props.$isDisabled &&
    css`
      background-color: ${props.theme.color[formElementThemes[props.$themeColor].background.disabled]};
    `};
`;

export const CharacterCounter = styled.div<{ $themeColor: FormElementThemeColor; $isDisabled: boolean }>`
  position: absolute;
  right: 20px;
  bottom: 0;
  z-index: 1;
  padding: 4px 6px 2px;
  font-size: 12px;
  font-weight: ${props => props.theme.fontWeight.semibold};
  line-height: 1;
  color: ${props => transparentize(0.6, props.theme.color[formElementThemes[props.$themeColor].text])};
  background-color: ${props => props.theme.color[formElementThemes[props.$themeColor].background.normal]};
  border-radius: ${props => props.theme.borderRadius.small} 0 0 0;

  ${props =>
    props.$isDisabled &&
    css`
      background-color: ${props.theme.color[formElementThemes[props.$themeColor].background.disabled]};
    `};
`;
